"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  // CMS Biz Objectives
  CREATE_ENGAGING_CONTENT: 'createEngagingContent',
  PERSONALIZE_EXPERIENCES: 'personalizeExperiences',
  GET_FOUND_ONLINE_CMS: 'getFoundOnlineCms',
  CAPTURE_CONVERT_LEADS_CMS: 'captureAndConvertLeadsCms',
  // Marketing Biz Objectives
  CAPTURE_CONVERT_LEADS_MARKETING: 'captureAndConvertLeadsMarketing',
  ENGAGE_LEADS: 'engageYourLeads',
  UNDERSTAND_LEADS: 'understandYourLeads',
  AUTOMATE_MARKETING: 'automateAndPersonalizeYourMarketing',
  GET_FOUND_ONLINE_MARKETING: 'getFoundOnlineMarketing',
  OPTIMIZE_CONVERSION: 'optimizeConversionRates',
  MEASURE_TRAFFIC_AND_CONVERSIONS: 'measureTrafficAndConversions',
  MANAGE_TEAMS_AND_BRANDS: 'manageYourTeamsAndBrands',
  EXTEND_PLATFORM: 'extendPlatform',
  ANALYZE_FULL_CONTROL: 'analyzeFullControl',
  // Sales Biz Objectives
  ORGANIZE_YOUR_SALES_PROCESS: 'orgranizeYourSalesProcess',
  CONNECT_WITH_PROSPECTS: 'connectWithProspects',
  TRACK_ITERATE_IMPROVE: 'trackIterateAndImprove',
  PERSONALIZE_OUTREACH: 'personalizeYourOutreach',
  COACH_AND_ENABLE: 'coachAndEnableAtScale',
  MANAGE_GROWING_TEAM: 'manageYourGrowingTeam',
  CONFIGURE_PRICE_QUOTE: 'configurePriceQuote',
  SCALE_YOUR_BUSINESS: 'scaleYourBusiness',
  SUPERCHARGE_YOUR_PIPELINE: 'superChargeYourPipeline',
  // Service Biz Objectives
  TRACK_CUSTOMER_COMMS: 'organizeAndTrackCustomerCommunications',
  MAXIMIZE_PRODUCTIVITY: 'maximizeProductivity',
  MEASURE_EFFICIENCY: 'measureEfficiency',
  DELIGHT_CUSTOMERS: 'delightCustomersAtScale',
  HELP_CUSTOMERS_HELP_THEMSELVES: 'helpCustomersHelpThemselves',
  MEASURE_IMPROVE_CUSTOMER_EXPERIENCE: 'measureImproveCustomerExperience',
  DELIVER_EXCEPTIONAL_SERVICE: 'deliverExceptionalService',
  MANAGE_MULTIPLE_TEAMS: 'manageMultipleTeamsAndBusinesses',
  ENABLE_SELF_SERVICE: 'enableSelfServiceAtScale',
  // CMS Hub Biz Objectives
  BUILD_REMARKABLE_WEB_PAGES: 'buildRemarkableWebPages',
  GROW_TRAFFIC_CONVERT_LEADS: 'growTrafficConvertLeads',
  SECURE_YOUR_WEBSITE: 'secureYourWebsite',
  BUILD_POWERFUL_WEB_EXPERIENCES: 'buildPowerfulWebExperiences',
  GOVERNANCE_AT_SCALE: 'governanceAtScale',
  EXTEND_YOUR_BRAND: 'extendYourBrand',
  // Mon333 biz objectives
  CONVERT_AND_NURTURE_LEADS: 'convertAndNurtureLeads',
  MEASURE_REVENUE: 'measureRevenue',
  ORGANIZE_YOUR_TEAM: 'organizeYourTeam',
  STREAMLINE_YOUR_OUTREACH: 'streamlineYourOutreach',
  HELP_AND_DELIGHT_CUSTOMERS: 'helpAndDelightCustomers',
  CREATE_REMARKABLE_WEBSITES: 'createRemarkableWebsites',
  CUSTOMIZE_USING_TOOLS: 'customizeUsingTools',
  GET_SPEED_RELIABILITY_SECURITY: 'getSpeedSecurityReliability'
};
exports.default = _default;
module.exports = exports.default;